import { Box, alpha } from "@bvhi/ui-base";
import { useTheme } from "@bvhi/ui-theme";
import { BounceLoader } from "react-spinners";

export const BVHIBounceDataGridLoader = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        minHeight: "100%",
        background: (theme) => alpha(theme.palette.primary.light, 0.2),
      }}
    >
      <BounceLoader color={theme.palette.primary.main} />
    </Box>
  );
};
